import FilesScreen from './FilesScreen';

export default FilesScreen;
